import { getRouteApi } from '@tanstack/react-router';

import { AnalysisValidation } from '@/features/estate-analytics/components/analysis-validation';
import { AnalyticsDashboard } from '@/features/estate-analytics/components/analytics-dashboard';

const route = getRouteApi(
  '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/analytics'
);

export const EstateAnalyticsDashboard = () => {
  const estate = route.useLoaderData();
  if (!estate.phDossierId) return <AnalysisValidation />;
  return <AnalyticsDashboard />;
};
